
@if (schedulerData) {
  <dx-scheduler
    #scheduler
    id="scheduler"
    class="date-scheduler {{currentView === 'month' ? ' month-view' : '' }}"
    [dataSource]="schedulerData"
    [views]="['day','week', 'month', 'year']"
    [currentView]="'month'"
    [currentDate]="currentDate"
    [firstDayOfWeek]="0"
    [startDayHour]="0"
    [endDayHour]="24"
    [showAllDayPanel]="true"
    [allDayExpr]="'allDay'"
    (onAppointmentClick)="toolTip($event)"
    (onAppointmentRendered)="setBackGroundColor($event)"
    (onCellContextMenu)="onCellContextMenu($event)"
    (onAppointmentContextMenu)="onAppointmentContextMenu($event)"
    (onContentReady)="onContentReady($event)"
    (onOptionChanged)="onOptionsChanged($event)"
    [appointmentTemplate]="!showAsDialog ? 'appointment-template' : ''"
    appointmentTooltipTemplate="tooltip-template"
    (onAppointmentUpdated)="onAppointmentUpdated($event)"
    >
    <div *dxTemplate="let model of 'appointment-template'">
      @if (model?.appointmentData?.name) {
        <div>
          <div>
            <div>{{ model?.appointmentData?.name }}</div>
            <!-- <div>{{ model?.appointmentData?.aMOffering ? 'AM - ' : 'PM - ' }}{{ model?.appointmentData?.name }} {{model?.appointmentData?.amount ? ' - $' + model?.appointmentData?.amount.toFixed(2) : ''}}</div> -->
          </div>
        </div>
      }
    </div>
    <div *dxTemplate="let data of 'tooltip-template'">
      <div class="dx-scheduler-tooltip" [ngStyle]="{color: data.appointmentData.color}">
        <div>{{ data.appointmentData.name }}</div>
      </div>
    </div>
    <dxi-view name="Day" type="day" [intervalCount]="1"  > </dxi-view>
    <dxi-view name="Week" type="week" [intervalCount]="2"> </dxi-view>
    <dxi-view name="Month" type="month" [intervalCount]="1"> </dxi-view>
    <dxi-view name="Year" type="month" [intervalCount]="12"> </dxi-view>
    <dxo-editing [allowUpdating]="true" [allowDragging]="true"></dxo-editing>
  </dx-scheduler>
}
<dx-context-menu
  #appointmentMenu
  [dataSource]="appointmentContextMenuItems"
  target=".dx-scheduler-appointment"
  (onItemClick)="onContextMenuItemClick($event)"
  [width]="325"
></dx-context-menu>
<dx-context-menu #cellMenu [dataSource]="cellContextMenuItems" target=".dx-scheduler-date-table-cell" (onItemClick)="onContextMenuItemClick($event)" [width]="200">
</dx-context-menu>
<!-- </div> -->
<!-- </div> -->
